var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgPlus = (_ref, ref) => {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/24/plus"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0292 9.74775C15.4421 9.74775 15.7769 9.41296 15.7769 8.99998C15.7769 8.587 15.4421 8.25222 15.0292 8.25222L9.74778 8.25221V3.07089C9.74778 2.65791 9.413 2.32313 9.00002 2.32313C8.58704 2.32313 8.25225 2.65791 8.25225 3.07089V8.25221L3.0811 8.25222C2.66812 8.25222 2.33333 8.587 2.33333 8.99998C2.33333 9.41296 2.66812 9.74775 3.0811 9.74775L8.25225 9.74775L8.25225 14.9291C8.25225 15.3421 8.58704 15.6768 9.00002 15.6768C9.413 15.6768 9.74778 15.342 9.74778 14.9291L9.74778 9.74775L15.0292 9.74775Z",
    fill: "#12171A"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPlus);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/plus.359b1ca0bce53071f7fd69b02e66d428.svg";